import { Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useDrpApplicationsData } from '../../hooks/useDrpApplicationsData';
import { StatusCard } from '../StatusCard';
import { DrpTierDataType, StatusCardColumnConfigItem } from '../../types';
import { getDrpSummary } from '../../../../utils/drp';
import { TierBadge } from '../../../dataInputs/tiers/components';

type DRPStatusWidgetProps = {
  locationUuid: string;
};

const drpTableColumnsConfig: StatusCardColumnConfigItem<DrpTierDataType>[] = [
  {
    title: 'Tier',
    dataIndex: 'tier',
    key: 'tier',
    span: 6,
    align: 'center',
    render: (tier: string, record: DrpTierDataType) => (
      <div className="flex justify-center">
        <TierBadge name={tier} color={record.color} />
      </div>
    ),
  },
  {
    title: '# of Applications',
    dataIndex: 'apps',
    key: 'apps',
    span: 9,
    align: 'center',
    render: (apps: number) => (
      <div className="flex justify-center">
        <span className="text-[14px] font-bold">{apps}</span>
      </div>
    ),
  },
  {
    title: 'DRPs',
    dataIndex: 'drps',
    key: 'drps',
    span: 6,
    align: 'center',
    render: (drps: number) => (
      <span className="text-[14px] font-bold">{drps}</span>
    ),
  },
  {
    title: '',
    key: 'action',
    span: 3,
    align: 'right',
    render: () => (
      <Button type="link" className="p-0 flex items-center justify-end w-full">
        <RightOutlined className="text-sm text-black" />
      </Button>
    ),
  },
];

export const DRPStatusWidget = ({ locationUuid }: DRPStatusWidgetProps) => {
  const { applications, loading: applicationsLoading } =
    useDrpApplicationsData(locationUuid);

  const {
    tierData: drpTierData,
    applicationsWithDrp,
    drpProgressPercent,
  } = getDrpSummary(applications);

  return (
    <StatusCard
      title="DRP Status"
      tooltipText="Breakdown of IT Applications by tier and DRP coverage."
      progressPercent={drpProgressPercent}
      progressValue={applicationsWithDrp}
      progressLabel="Applications with DRP"
      tableColumnsConfig={drpTableColumnsConfig}
      tableData={drpTierData}
      tableMaxHeight="250px"
      disabled={applicationsLoading}
      showComingSoon={false}
    />
  );
};
